import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'xvi-purchase-order-card',
  templateUrl: './xvi-purchase-order-summary-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxInventoryOrderSummaryCardComponent {
  public constructor() {}
}
